import projectBoardComponent from './project-board.component';

const projectBoardModule = angular.module('projectBoard', [
])
  .component('projectBoard', projectBoardComponent)
  .name;

export default projectBoardModule;
